import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../api.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {

  constructor(private api : ApiService) { }

  ngOnInit() {
  }

  cancel(){
    this.api.cancelCurrentRequest();
  }
}
